/**
 * Settings.
 * @exports BlockComponents.settings
 * @type Object
 * @property {string} [prefix=block]
 *   Brand prefix. Should be in sync with `$prefix` Sass variable in ./src/globals/scss/_vars.scss.
 */
const settings = {
    prefix: 'coastal',
};
export default settings;